import { Controller } from "@hotwired/stimulus"

// Drives the per-student reminder picker on the admin session page.
//
// The whole Booked Students table is one form: row checkboxes send
// booking_ids[], while a row's "Remind" button submits booking_id for just that
// person. Everything here is about not sending a text by accident -- the bulk
// button stays disabled until something is selected, and every send is
// confirmed with the names and channels spelled out.
export default class extends Controller {
  static targets = ["checkbox", "selectAll", "submit", "count", "channel"]

  connect() {
    this.refresh()
  }

  toggleAll() {
    this.checkboxTargets.forEach((box) => {
      box.checked = this.selectAllTarget.checked
    })
    this.refresh()
  }

  refresh() {
    const selected = this.selectedCount

    if (this.hasCountTarget) this.countTarget.textContent = selected
    if (this.hasSubmitTarget) this.submitTarget.disabled = selected === 0

    if (this.hasSelectAllTarget) {
      const total = this.checkboxTargets.length
      this.selectAllTarget.checked = total > 0 && selected === total
      this.selectAllTarget.indeterminate = selected > 0 && selected < total
    }
  }

  confirmSend(event) {
    const channels = this.selectedChannels

    if (channels.length === 0) {
      event.preventDefault()
      event.stopImmediatePropagation()
      window.alert("Pick at least one channel -- email, SMS, or both.")
      return
    }

    const recipients = this.describeRecipients(event.submitter)
    if (recipients === null) {
      event.preventDefault()
      event.stopImmediatePropagation()
      return
    }

    const message =
      `Send the course reminder by ${this.listChannels(channels)} to ${recipients}?\n\n` +
      "Only these students are messaged -- nobody else on this session is contacted again."

    if (!window.confirm(message)) {
      event.preventDefault()
      event.stopImmediatePropagation()
    }
  }

  // A row's Remind button names the one student; the toolbar button covers
  // whatever is ticked. Returns null when there is nothing to send.
  describeRecipients(submitter) {
    if (submitter && submitter.name === "booking_id") {
      return submitter.dataset.studentName || "this student"
    }

    const selected = this.selectedCount
    if (selected === 0) return null

    return selected === 1 ? "1 student" : `${selected} students`
  }

  listChannels(channels) {
    const labels = channels.map((channel) => (channel === "sms" ? "SMS" : "email"))
    return labels.join(" and ")
  }

  get selectedCount() {
    return this.checkboxTargets.filter((box) => box.checked).length
  }

  get selectedChannels() {
    return this.channelTargets.filter((box) => box.checked).map((box) => box.value)
  }
}
